// extracted by mini-css-extract-plugin
module.exports = {"news_top":"news_top-1PMR_KNt"};